import {
  UserState,
  US_Filter,
  US_PreFilterInteractives,
  PodLayoutEx,
} from "../models";
import {
  ShareState,
  SubscriptionShareState,
  GroupShareState,
} from "../../elements/share-editor/share-editor.component";
import { US_SubHeader } from "../models/us_sub-header";
import { EnumShareMode } from "../models/enum-share-mode";
import { US_Bookmark } from "../models/us_bookmark";
import { US_ReportExport } from "../models/us_report-export";
import { US_ModifiedInteractive } from "../models/us_modified-interactive";
import { UpdateSharingStatus } from "../models/update-sharing-status";

export class UserStateEx {
  static getFilterShareState(
    userState: UserState,
    filter: US_Filter
  ): ShareState {
    const returnValue: ShareState = {
      subscriptionShareStates: [],
    };

    const currentShares = filter.shares;
    const subs: US_SubHeader[] = [];

    for (let i = 0; i < userState.interactives.length; i++) {
      if (userState.interactives[i].interactId === filter.interactId) {
        for (
          let e = 0;
          e < userState.interactives[i].subscriptionHeaders.length;
          e++
        ) {
          subs.push(userState.interactives[i].subscriptionHeaders[e]);
        }
      }
    }

    for (let i = 0; i < currentShares.length; i++) {
      if (currentShares[i].filterId === filter.filterId) {
        const share = currentShares[i];
        for (let e = 0; e < subs.length; e++) {
          const sub = subs[e];
          let shareState: SubscriptionShareState = null;

          for (let z = 0; z < returnValue.subscriptionShareStates.length; z++) {
            if (
              returnValue.subscriptionShareStates[z].subscriptionId ===
              sub.subscriptionId
            ) {
              shareState = returnValue.subscriptionShareStates[z];
            }
          }

          for (let z = 0; z < subs[e].subscriptionGroups.length; z++) {
            const group = subs[e].subscriptionGroups[z];
            if (share.subscriptionGroupId === group.subscriptionGroupId) {
              if (!shareState) {
                shareState = {
                  subscriptionId: sub.subscriptionId,
                  groupShareStates: [],
                };
                returnValue.subscriptionShareStates.push(shareState);
              }

              let groupState: GroupShareState = null;
              for (let y = 0; y < shareState.groupShareStates.length; y++) {
                if (
                  shareState.groupShareStates[y].subscriptionGroupId ===
                  share.subscriptionGroupId
                ) {
                  groupState = shareState.groupShareStates[y];
                }
              }

              if (!groupState) {
                groupState = {
                  subscriptionGroupId: share.subscriptionGroupId,
                  notShared: false,
                  readOnly: false,
                  allowModify: false,
                };

                shareState.groupShareStates.push(groupState);
              }

              groupState.notShared = share.shareMode === 0;
              groupState.readOnly = share.shareMode === 1;
              groupState.allowModify = share.shareMode === 2;
            }
          }
        }
      }
    }

    return returnValue;
  }

  static getBookmarkShareState(
    userState: UserState,
    bookmark: US_Bookmark
  ): ShareState {
    const returnValue: ShareState = {
      subscriptionShareStates: [],
    };

    const currentShares = bookmark.shares;
    const subs: US_SubHeader[] = [];

    for (let i = 0; i < userState.interactives.length; i++) {
      if (userState.interactives[i].interactId === bookmark.interactId) {
        for (
          let e = 0;
          e < userState.interactives[i].subscriptionHeaders.length;
          e++
        ) {
          subs.push(userState.interactives[i].subscriptionHeaders[e]);
        }
      }
    }

    for (let i = 0; i < currentShares.length; i++) {
      if (currentShares[i].bookmarkId === bookmark.bookmarkId) {
        const share = currentShares[i];
        for (let e = 0; e < subs.length; e++) {
          const sub = subs[e];
          let shareState: SubscriptionShareState = null;

          for (let z = 0; z < returnValue.subscriptionShareStates.length; z++) {
            if (
              returnValue.subscriptionShareStates[z].subscriptionId ===
              sub.subscriptionId
            ) {
              shareState = returnValue.subscriptionShareStates[z];
            }
          }

          for (let z = 0; z < subs[e].subscriptionGroups.length; z++) {
            const group = subs[e].subscriptionGroups[z];
            if (share.subscriptionGroupId === group.subscriptionGroupId) {
              if (!shareState) {
                shareState = {
                  subscriptionId: sub.subscriptionId,
                  groupShareStates: [],
                };
                returnValue.subscriptionShareStates.push(shareState);
              }

              let groupState: GroupShareState = null;
              for (let y = 0; y < shareState.groupShareStates.length; y++) {
                if (
                  shareState.groupShareStates[y].subscriptionGroupId ===
                  share.subscriptionGroupId
                ) {
                  groupState = shareState.groupShareStates[y];
                }
              }

              if (!groupState) {
                groupState = {
                  subscriptionGroupId: share.subscriptionGroupId,
                  notShared: false,
                  readOnly: false,
                  allowModify: false,
                };

                shareState.groupShareStates.push(groupState);
              }

              groupState.notShared = share.shareMode === 0;
              groupState.readOnly = share.shareMode === 1;
              groupState.allowModify = share.shareMode === 2;
            }
          }
        }
      }
    }

    return returnValue;
  }

  static getReportExportShareState(
    userState: UserState,
    report: US_ReportExport
  ): ShareState {
    const returnValue: ShareState = {
      subscriptionShareStates: [],
    };

    const currentShares = report.shares;
    const subs: US_SubHeader[] = [];

    for (let i = 0; i < userState.interactives.length; i++) {
      if (userState.interactives[i].interactId === report.interactId) {
        for (
          let e = 0;
          e < userState.interactives[i].subscriptionHeaders.length;
          e++
        ) {
          subs.push(userState.interactives[i].subscriptionHeaders[e]);
        }
      }
    }

    for (let i = 0; i < currentShares.length; i++) {
      if (
        currentShares[i].subInteractReportExportId ===
        report.subInteractReportExportId
      ) {
        const share = currentShares[i];
        for (let e = 0; e < subs.length; e++) {
          const sub = subs[e];
          let shareState: SubscriptionShareState = null;

          for (let z = 0; z < returnValue.subscriptionShareStates.length; z++) {
            if (
              returnValue.subscriptionShareStates[z].subscriptionId ===
              sub.subscriptionId
            ) {
              shareState = returnValue.subscriptionShareStates[z];
            }
          }

          for (let z = 0; z < subs[e].subscriptionGroups.length; z++) {
            const group = subs[e].subscriptionGroups[z];
            if (share.subscriptionGroupId === group.subscriptionGroupId) {
              if (!shareState) {
                shareState = {
                  subscriptionId: sub.subscriptionId,
                  groupShareStates: [],
                };
                returnValue.subscriptionShareStates.push(shareState);
              }

              let groupState: GroupShareState = null;
              for (let y = 0; y < shareState.groupShareStates.length; y++) {
                if (
                  shareState.groupShareStates[y].subscriptionGroupId ===
                  share.subscriptionGroupId
                ) {
                  groupState = shareState.groupShareStates[y];
                }
              }

              if (!groupState) {
                groupState = {
                  subscriptionGroupId: share.subscriptionGroupId,
                  notShared: false,
                  readOnly: false,
                  allowModify: false,
                };

                shareState.groupShareStates.push(groupState);
              }

              groupState.notShared = share.shareMode === 0;
              groupState.readOnly = share.shareMode === 1;
              groupState.allowModify = share.shareMode === 2;
            }
          }
        }
      }
    }

    return returnValue;
  }

  static getModifiedInteractiveShareState(
    userState: UserState,
    interactive: US_ModifiedInteractive
  ): ShareState {
    const returnValue: ShareState = {
      subscriptionShareStates: [],
    };

    const currentShares = interactive.shares;
    const subs: US_SubHeader[] = [];

    for (let i = 0; i < userState.modifiedInteractives.length; i++) {
      if (
        userState.modifiedInteractives[i].interactId === interactive.interactId
      ) {
        for (
          let e = 0;
          e < userState.modifiedInteractives[i].subscriptionHeaders.length;
          e++
        ) {
          subs.push(userState.modifiedInteractives[i].subscriptionHeaders[e]);
        }
      }
    }

    for (let i = 0; i < currentShares.length; i++) {
      if (currentShares[i].modInteractId === interactive.modInteractId) {
        const share = currentShares[i];
        for (let e = 0; e < subs.length; e++) {
          const sub = subs[e];
          let shareState: SubscriptionShareState = null;

          for (let z = 0; z < returnValue.subscriptionShareStates.length; z++) {
            if (
              returnValue.subscriptionShareStates[z].subscriptionId ===
              sub.subscriptionId
            ) {
              shareState = returnValue.subscriptionShareStates[z];
            }
          }

          for (let z = 0; z < subs[e].subscriptionGroups.length; z++) {
            const group = subs[e].subscriptionGroups[z];
            if (share.subscriptionGroupId === group.subscriptionGroupId) {
              if (!shareState) {
                shareState = {
                  subscriptionId: sub.subscriptionId,
                  groupShareStates: [],
                };
                returnValue.subscriptionShareStates.push(shareState);
              }

              let groupState: GroupShareState = null;
              for (let y = 0; y < shareState.groupShareStates.length; y++) {
                if (
                  shareState.groupShareStates[y].subscriptionGroupId ===
                  share.subscriptionGroupId
                ) {
                  groupState = shareState.groupShareStates[y];
                }
              }

              if (!groupState) {
                groupState = {
                  subscriptionGroupId: share.subscriptionGroupId,
                  notShared: false,
                  readOnly: false,
                  allowModify: false,
                };

                shareState.groupShareStates.push(groupState);
              }

              groupState.notShared = share.shareMode === 0;
              groupState.readOnly = share.shareMode === 1;
              groupState.allowModify = share.shareMode === 2;
            }
          }
        }
      }
    }

    return returnValue;
  }

  static getPreFilteredInteractiveShareState(
    userState: UserState,
    interactive: US_PreFilterInteractives
  ): ShareState {
    const returnValue: ShareState = {
      subscriptionShareStates: [],
    };

    const currentShares = interactive.shares;
    const subs: US_SubHeader[] = [];

    for (let i = 0; i < userState.preFilteredInteractives.length; i++) {
      if (
        userState.preFilteredInteractives[i].preFilteredInteractiveId ===
        interactive.preFilteredInteractiveId
      ) {
        for (
          let e = 0;
          e < userState.preFilteredInteractives[i].subscriptionHeaders.length;
          e++
        ) {
          subs.push(
            userState.preFilteredInteractives[i].subscriptionHeaders[e]
          );
        }
      }
    }

    for (let i = 0; i < currentShares.length; i++) {
      if (
        currentShares[i].preFilterInteractiveId ===
        interactive.preFilteredInteractiveId
      ) {
        const share = currentShares[i];
        for (let e = 0; e < subs.length; e++) {
          const sub = subs[e];
          let shareState: SubscriptionShareState = null;

          for (let z = 0; z < returnValue.subscriptionShareStates.length; z++) {
            if (
              returnValue.subscriptionShareStates[z].subscriptionId ===
              sub.subscriptionId
            ) {
              shareState = returnValue.subscriptionShareStates[z];
            }
          }

          for (let z = 0; z < subs[e].subscriptionGroups.length; z++) {
            const group = subs[e].subscriptionGroups[z];
            if (share.subscriptionGroupId === group.subscriptionGroupId) {
              if (!shareState) {
                shareState = {
                  subscriptionId: sub.subscriptionId,
                  groupShareStates: [],
                };
                returnValue.subscriptionShareStates.push(shareState);
              }

              let groupState: GroupShareState = null;
              for (let y = 0; y < shareState.groupShareStates.length; y++) {
                if (
                  shareState.groupShareStates[y].subscriptionGroupId ===
                  share.subscriptionGroupId
                ) {
                  groupState = shareState.groupShareStates[y];
                }
              }

              if (!groupState) {
                groupState = {
                  subscriptionGroupId: share.subscriptionGroupId,
                  notShared: false,
                  readOnly: false,
                  allowModify: false,
                };

                shareState.groupShareStates.push(groupState);
              }

              groupState.notShared = share.shareMode === 0;
              groupState.readOnly = share.shareMode === 1;
              groupState.allowModify = share.shareMode === 2;
            }
          }
        }
      }
    }

    return returnValue;
  }

  static getPodLayoutShareState(
    userState: UserState,
    podLayout: PodLayoutEx
  ): ShareState {
    const returnValue: ShareState = {
      subscriptionShareStates: [],
    };

    const currentShares = podLayout.shares;
    const subs: US_SubHeader[] = [];

    for (let i = 0; i < userState.interactives.length; i++) {
      if (userState.interactives[i].interactId === podLayout.interactId) {
        for (
          let e = 0;
          e < userState.interactives[i].subscriptionHeaders.length;
          e++
        ) {
          subs.push(userState.interactives[i].subscriptionHeaders[e]);
        }
      }
    }

    for (let i = 0; i < currentShares.length; i++) {
      if (currentShares[i].podLayoutId === podLayout.podLayoutId) {
        const share = currentShares[i];
        for (let e = 0; e < subs.length; e++) {
          const sub = subs[e];
          let shareState: SubscriptionShareState = null;

          for (let z = 0; z < returnValue.subscriptionShareStates.length; z++) {
            if (
              returnValue.subscriptionShareStates[z].subscriptionId ===
              sub.subscriptionId
            ) {
              shareState = returnValue.subscriptionShareStates[z];
            }
          }

          for (let z = 0; z < subs[e].subscriptionGroups.length; z++) {
            const group = subs[e].subscriptionGroups[z];
            if (share.subscriptionGroupId === group.subscriptionGroupId) {
              if (!shareState) {
                shareState = {
                  subscriptionId: sub.subscriptionId,
                  groupShareStates: [],
                };
                returnValue.subscriptionShareStates.push(shareState);
              }

              let groupState: GroupShareState = null;
              for (let y = 0; y < shareState.groupShareStates.length; y++) {
                if (
                  shareState.groupShareStates[y].subscriptionGroupId ===
                  share.subscriptionGroupId
                ) {
                  groupState = shareState.groupShareStates[y];
                }
              }

              if (!groupState) {
                groupState = {
                  subscriptionGroupId: share.subscriptionGroupId,
                  notShared: false,
                  readOnly: false,
                  allowModify: false,
                };

                shareState.groupShareStates.push(groupState);
              }

              groupState.notShared = share.shareMode === 0;
              groupState.readOnly = share.shareMode === 1;
              groupState.allowModify = share.shareMode === 2;
            }
          }
        }
      }
    }

    return returnValue;
  }

  static getSharingStatus(shareState: ShareState): UpdateSharingStatus[] {
    const results: UpdateSharingStatus[] = [];

    for (let i = 0; i < shareState.subscriptionShareStates.length; i++) {
      const sub = shareState.subscriptionShareStates[i];
      for (let e = 0; e < sub.groupShareStates.length; e++) {
        const group = sub.groupShareStates[e];

        if (!group.notShared) {
          let status: UpdateSharingStatus = null;

          if (group.readOnly) {
            status = UserStateEx.getExisting(results, sub.subscriptionId, 1);
          }
          if (group.allowModify) {
            status = UserStateEx.getExisting(results, sub.subscriptionId, 2);
          }

          if (status) {
            status.groupIds.push(group.subscriptionGroupId);
          } else {
            results.push({
              subscriptionId: sub.subscriptionId,
              shareMode: group.readOnly ? 1 : 2,
              groupIds: [group.subscriptionGroupId],
            });
          }
        }
      }
    }

    return results;
  }

  static getExisting(
    results: UpdateSharingStatus[],
    subscriptionId: number,
    shareMode: EnumShareMode
  ): UpdateSharingStatus | null {
    for (let i = 0; i < results.length; i++) {
      if (
        results[i].subscriptionId === subscriptionId &&
        results[i].shareMode === shareMode
      ) {
        return results[i];
      }
    }
    return null;
  }
}
